import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  LinearProgress,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { orderslabel } from "../api";
import { useSnackbar } from "notistack";
import { HOST_API } from "src/config";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PRINT_STYLES = `
  @page {
    size: A4 portrait;
    margin: 6mm;
  }

  @media print {
    body > * { display: none !important; }
    #label-print-root { display: block !important; }

    #label-print-root {
      width: 100%;
    }

    .label-page {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      width: 100%;
      height: calc(297mm - 12mm);
      page-break-after: always;
      break-after: page;
      gap: 3mm;
      box-sizing: border-box;
    }

    .label-page:last-child {
      page-break-after: avoid;
      break-after: avoid;
    }

    .label-card {
      border: 1.5px solid #111;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      font-size: 9pt;
      font-family: Arial, sans-serif;
    }

    .label-header {
      display: grid;
      grid-template-columns: 80px 1fr 70px;
      border-bottom: 1.5px solid #111;
      min-height: 36px;
    }
    .label-header > div {
      padding: 2px 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .label-header > div:not(:last-child) {
      border-right: 1.5px solid #111;
    }
    .label-header img { width: 60px; }

    .label-pkg-header {
      display: grid;
      grid-template-columns: 1fr 60px 30px 60px;
      border-bottom: 1.5px solid #111;
    }
    .label-pkg-header > div,
    .label-pkg-row > div {
      padding: 1px 3px;
      border-right: 1.5px solid #111;
      font-size: 8pt;
    }
    .label-pkg-header > div:last-child,
    .label-pkg-row > div:last-child { border-right: none; }
    .label-pkg-header { font-weight: bold; }

    .label-pkg-row {
      display: grid;
      grid-template-columns: 1fr 60px 30px 60px;
      border-bottom: 1.5px solid #111;
    }

    .label-body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      flex: 1;
    }
    .label-body-left {
      border-right: 1.5px solid #111;
      padding: 3px 4px;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .label-body-right {
      padding: 3px 4px;
      font-size: 8pt;
    }

    .label-address {
      border-top: 1.5px solid #111;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .label-address-left {
      border-right: 1.5px solid #111;
      padding: 3px 4px;
      font-size: 8pt;
    }
    .label-address-right {
      padding: 3px 4px;
    }

    .label-barcode {
      border-top: 1.5px solid #111;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .label-barcode-left {
      border-right: 1.5px solid #111;
      padding: 2px 4px;
    }
    .label-barcode-right {
      padding: 2px 4px;
    }

    b { font-weight: bold; }
  }
`;

function chunk(arr, n) {
  const result = [];
  for (let i = 0; i < arr.length; i += n) result.push(arr.slice(i, i + n));
  return result;
}

const LabelCard = ({ item, vendorDetails, style = {} }) => (
  <div style={{
    border: "1.5px solid #111",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Arial, sans-serif",
    fontSize: "9pt",
    backgroundColor: "#fff",
    ...style,
  }}>
    {/* Header */}
    <div style={{ display: "grid", gridTemplateColumns: "80px 1fr 70px", borderBottom: "1.5px solid #111", minHeight: 38 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1.5px solid #111", padding: "2px 4px" }}>
        {vendorDetails?.image ? (
          <img src={`${HOST_API}images/product/${vendorDetails.image}`} alt="logo" style={{ width: 60 }} />
        ) : null}
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1.5px solid #111", padding: "2px 4px", fontWeight: "bold" }}>
        {item?.shippingType}
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "2px 4px", fontSize: "8pt" }}>
        <span>Online</span>
        <span>{item?.totalAmount || 0}</span>
      </div>
    </div>

    {/* Package header */}
    <div style={{ display: "grid", gridTemplateColumns: "1fr 60px 30px 60px", borderBottom: "1.5px solid #111", fontWeight: "bold", fontSize: "8pt", minHeight: 30 }}>
      {["Package Name", "Price", "Qty", "Total"].map((h, i) => (
        <div key={i} style={{ padding: "1px 3px", borderRight: i < 3 ? "1.5px solid #111" : "none" }}>{h}</div>
      ))}
    </div>

    {/* Package row */}
    <div style={{ display: "grid", gridTemplateColumns: "1fr 60px 30px 60px", borderBottom: "1.5px solid #111", fontSize: "8pt", minHeight: 40 }}>
      <div style={{ padding: "1px 3px", borderRight: "1.5px solid #111", wordBreak: "break-word" }}>{item?.packageName || ""}</div>
      <div style={{ padding: "1px 3px", borderRight: "1.5px solid #111" }}>{item?.totalPrice}</div>
      <div style={{ padding: "1px 3px", borderRight: "1.5px solid #111" }}>1</div>
      <div style={{ padding: "1px 3px" }}>{item?.totalPrice}</div>
    </div>

    {/* Note + Products */}
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", flex: 1 }}>
      <div style={{ borderRight: "1.5px solid #111", padding: "3px 4px", fontSize: "8pt" }}>
        <div><b>Note</b> - No Open Delivery Allowed</div>
        <div><b>OrderId:</b> {item?.orderID}</div>
        {item?.houseName && <div><b>House Name:</b> {item.houseName}</div>}
        {item?.division && <div><b>Grade:</b> {item.division}</div>}
      </div>
      <div style={{ padding: "3px 4px", fontSize: "8pt" }}>
        <div><b>Product Name:</b></div>
        {item?.products?.map((p, i) => <div key={i}>• {p.productName}</div>)}
      </div>
    </div>

    {/* Address */}
    <div style={{ borderTop: "1.5px solid #111", padding: "3px 4px", fontSize: "8pt" }}>
      <div><b>To: {item.parentFirstName || ""} {item?.parentLastName || ""}</b></div>
      <div>{item?.address1 || ""}, {item?.address2 || ""} {item?.city || ""} {item?.stateName || ""}, <b>{item?.pin || ""}</b></div>
      <div style={{ marginTop: 4 }}><b>Contact:</b> {item?.mobile || ""}</div>
    </div>

    {/* Barcode */}
    <div style={{ borderTop: "1.5px solid #111", padding: "2px 4px" }}>
      <Barcode
        value={item?.orderID || "000000"}
        format="CODE128"
        height={45}
        width={1.2}
        displayValue
        fontSize={8}
        margin={2}
      />
    </div>
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const GenerateLabel = ({ onClose, data, isVariation = false }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [labelData, setData] = useState([]);
  const [vendorDetails, setVendorDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const printRef = useRef();
  const pdfAllPagesRef = useRef();

  const fetchLabel = (lebelId) => {
    if (!lebelId) return;
    setLoading(true);
    const orderId = lebelId.map((el) => el?.original?.orderID).join(",");
    orderslabel({ orderIDs: orderId, isVariation })
      .then((res) => {
        setLoading(false);
        if (res.length > 0) {
          const extractedVendorDetails = res.find((item) => item.vendorDetails)?.vendorDetails;
          setVendorDetails(extractedVendorDetails);
          setData(res.filter((item) => item.orderID));
          return;
        }
        enqueueSnackbar("Label details not present for provided order ID", { variant: "error" });
      })
      .catch(() => {
        enqueueSnackbar("Something Went Wrong", { variant: "error" });
        setLoading(false);
      });
  };

  useEffect(() => { fetchLabel(data); }, [data]);

  // Inject print CSS
  useEffect(() => {
    const style = document.createElement("style");
    style.id = "label-print-style";
    style.innerHTML = PRINT_STYLES;
    document.head.appendChild(style);
    return () => { document.getElementById("label-print-style")?.remove(); };
  }, []);

  // Print
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    copyStyles: true,
  });

  // PDF Export
  const handleExportPDF = async () => {
    if (!pdfAllPagesRef.current) return;
    setPdfLoading(true);
    try {
      const container = pdfAllPagesRef.current;
      const canvas = await html2canvas(container, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
      });

      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const A4_W = 210;
      const A4_H = 297;
      const margin = 6;
      const usableW = A4_W - margin * 2;
      const usableH = A4_H - margin * 2;

      const PAGE_H_PX = 1123;
      const totalPages = pages.length;

      for (let i = 0; i < totalPages; i++) {
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = Math.round(PAGE_H_PX * (canvas.width / 794));
        const ctx = pageCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0, Math.round(i * PAGE_H_PX * (canvas.width / 794)),
          canvas.width, pageCanvas.height,
          0, 0,
          pageCanvas.width, pageCanvas.height
        );
        const imgData = pageCanvas.toDataURL("image/jpeg", 0.8);
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", margin, margin, usableW, usableH);
      }

      pdf.save(`label-${new Date().toDateString()}.pdf`);
    } catch (err) {
      enqueueSnackbar("PDF export failed", { variant: "error" });
      console.error(err);
    }
    setPdfLoading(false);
  };

  const pages = chunk(labelData, 4);

  return (
    <Dialog fullScreen open onClose={onClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">Download Label</Typography>
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            &times;
          </IconButton>
        </Toolbar>
      </AppBar>

      {(loading || pdfLoading) && <LinearProgress />}

      <DialogContent sx={{ background: "#f0f0f0", p: 2 }}>

        {/* Hidden print root */}
        <div
          id="label-print-root"
          ref={printRef}
          style={{ display: "none" }}
        >
          {pages.map((page, pi) => (
            <div
              key={pi}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "1fr 1fr",
                width: "100%",
                height: "calc(297mm - 12mm)",
                pageBreakAfter: "always",
                gap: "3mm",
                boxSizing: "border-box",
              }}
            >
              {page.map((item) => (
                <LabelCard key={item.orderID} item={item} vendorDetails={vendorDetails} />
              ))}
              {page.length < 4 &&
                Array.from({ length: 4 - page.length }).map((_, i) => (
                  <div key={`empty-${i}`} style={{ boxSizing: "border-box" }} />
                ))}
            </div>
          ))}
        </div>

        {/* Hidden PDF render */}
        <div
          ref={pdfAllPagesRef}
          style={{ position: "absolute", left: "-9999px", top: 0, pointerEvents: "none", width: "794px" }}
        >
          {pages.map((page, pi) => (
            <div
              key={pi}
              style={{
                width: "794px",
                height: "1123px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "1fr 1fr",
                gap: "6px",
                padding: "10px",
                boxSizing: "border-box",
                backgroundColor: "#fff",
              }}
            >
              {page.map((item) => (
                <LabelCard key={item.orderID} item={item} vendorDetails={vendorDetails} />
              ))}
              {page.length < 4 &&
                Array.from({ length: 4 - page.length }).map((_, i) => (
                  <div key={`empty-${i}`} style={{ boxSizing: "border-box", backgroundColor: "#fff" }} />
                ))}
            </div>
          ))}
        </div>

        {/* Visible screen preview */}
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          {pages.map((page, pi) => (
            <div
              key={pi}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px",
                marginBottom: "24px",
                background: "#fff",
                padding: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              {page.map((item) => (
                <LabelCard key={item.orderID} item={item} vendorDetails={vendorDetails} />
              ))}
              {page.length < 4 &&
                Array.from({ length: 4 - page.length }).map((_, i) => (
                  <div key={`empty-${i}`} style={{ border: "1.5px dashed #eee", minHeight: 200 }} />
                ))}
            </div>
          ))}
        </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">Cancel</Button>
        <Button
          onClick={handleExportPDF}
          disabled={loading || pdfLoading || !labelData.length}
          variant="contained"
          color="primary"
        >
          {pdfLoading ? "Generating PDF..." : "Export to PDF"}
        </Button>
        <Button
          onClick={handlePrint}
          disabled={loading || !labelData.length}
          variant="contained"
          color="error"
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateLabel;